import { __, invertObj, prop } from 'ramda';

import { THEMATIC } from '../../../types/filters';

/** @deprecated */
const PRISMIC_TO_TYPE_THEMATIC = {
  'Banque et assurance': THEMATIC.BANK,
  'Courrier et colis': THEMATIC.LETTER_PACKAGE,
  'Développement territorial': THEMATIC.DT,
  'Excellence logistique': THEMATIC.EXCELLENCE,
  Innovation: THEMATIC.INNOVATION,
  International: THEMATIC.INTERNATIONAL,
  'Logistique urbaine': THEMATIC.LOGISTIC,
  Médias: THEMATIC.MEDIA,
  Partenariats: THEMATIC.PARTNERSHIP,
  'Ressources humaines': THEMATIC.HUMAN_RESOURCES,
  'Services à la personne': THEMATIC.HOME_SERVICE,
  Télécom: THEMATIC.TELECOM,
  'Transformation numérique': THEMATIC.DIGITAL,
  'Transitions écologiques': THEMATIC.ECOLOGY,
  Philatélie: THEMATIC.PHILATELY,
};

/** @deprecated */
export const toThematicType = prop(__, PRISMIC_TO_TYPE_THEMATIC);
/** @deprecated */
export const toThematicPrismic = prop(__, invertObj(PRISMIC_TO_TYPE_THEMATIC));
